const users = {
	title: "Brukere",
	new_user: "Ny bruker",
	edit_user: "Rediger bruker: {name}",
	edit_role: "Rediger rolle: {name}",
	view_user: "Vis bruker: {name}",
	person_title: "Bruker detaljer",
	list_title: "Brukere",
	list_subtitle: "Håndtere brukere",
	details_title: "Bruker detaljer",
	account_title: "Kontodetaljer",
	address_title: "Addresse detaljer",
	organisation_title: "Organisasjons detaljer",
	id: "ID",
	first_name: "Fornavn",
	last_name: "Etternavn",
	middle_name: "Mellomnavn",
	mobile: "Mobil",
	status: "Status",
	email: "Epost",
	password: "Passord",
	search_organisations: "Finn organisasjoner...",
	profile: "Profil",
	changepass: "Endre passord",
	course_types_and_group: "Kompetanseområder og kompetansegrupper",
	is_instructor: "Instruktør",
	edit: {
		password_no_match: "Passord er ikke likt",
		personal_info: "Personlig informasjon",
		old_pass: "Nåværende passord",
		new_pass: "Nytt passord",
		confirm_pass: "Bekreft passord",
		password_success: "Passord endret.",
		password_error: "Endring av passord feilet. Nåværende passord er feil!",
	},
};
export default users;